import {
  INITIALISE,
  LOGIN_REQUEST,
  LOGIN_REQUEST_MODAL,
  LOGIN_SUCCESS,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_FILIAL,
  CHOOSE_FILIAL,
  SET_LOADING,
} from './auth-constants';

export const initialise = token => {
  return {
    type: INITIALISE,
    token
  };
};

export const setLoading = loading => {
  return {
    type: SET_LOADING,
    loading
  };
};

export const setFilial = filiais => {
  return {
    type: SET_FILIAL,
    filiais
  };
};

export const chooseFilial = payload => {
  return {
    type: CHOOSE_FILIAL,
    payload
  };
};

export const loginRequest = payload => {
  return {
    type: LOGIN_REQUEST,
    payload
  };
};

export const loginRequestModal = payload => {
  return {
    type: LOGIN_REQUEST_MODAL,
    payload
  };
};

export const loginSuccess = payload => {
  return {
    type: LOGIN_SUCCESS,
    payload
  };
};

export const logoutRequest = () => {
  return { type: LOGOUT_REQUEST };
};

export const logoutSuccess = () => {
  return { type: LOGOUT_SUCCESS };
};

